import { useSearchParams } from 'next/navigation'
import { useEffect, useMemo, useState } from 'react'

import { getDataFromSessionStorage } from 'src/utils/sessionStorage'

export const REFERRED_BY_QUERY = 'referred_by'

type AffiliateFormValuesReturnType<T> = T & { referredBy: string }

type AffiliateFormValuesReturn<T> = [AffiliateFormValuesReturnType<T>, (value: string) => string]

const transformAffiliate = (value?: string): string => value?.toUpperCase() || ''

const useAffiliateFormValuesExtension = <T extends { referredBy: string } = { referredBy: string }>(
  initialValues: T,
): AffiliateFormValuesReturn<T> => {
  const query = useSearchParams()
  const [values, setValues] = useState<AffiliateFormValuesReturnType<T>>(initialValues)

  useEffect(() => {
    setValues(initialValues)
  }, [initialValues])

  useEffect(() => {
    const referredByQuery = query.get(REFERRED_BY_QUERY)
    const referredBySessionStorage = getDataFromSessionStorage<string>(REFERRED_BY_QUERY)

    const referredBy = referredByQuery || referredBySessionStorage

    if (referredBy) {
      setValues((prevValues) => ({ ...prevValues, referredBy: transformAffiliate(referredBy) }))
    }
  }, [query, initialValues])

  return useMemo(() => [values, transformAffiliate], [values])
}

export default useAffiliateFormValuesExtension
